import type { NodeTransformer } from './types';

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const DIGITS_ONLY_REGEX = /^\d+$/;

const fixTimestamp = <T>(timestamp: T): T | string => {
	const currentTime = new Date().getTime().toString();

	if (!timestamp) {
		return currentTime;
	}

	if (typeof timestamp !== 'string') {
		return timestamp;
	}

	if (timestamp.includes('-')) {
		const time = new Date(timestamp).getTime();

		return isNaN(time) ? currentTime : time.toString();
	}

	if (!timestamp.match(DIGITS_ONLY_REGEX)) {
		return currentTime;
	}

	return timestamp;
};

export const toSupportedDate: NodeTransformer = ({ attrs = {}, ...rest }) => ({
	...rest,
	attrs: { ...attrs, timestamp: fixTimestamp(attrs.timestamp) },
});
